$(document).ready(function () {
  initializeMobileNav();
  initializeToggleNav();
  initializeToggleLogin();
});

var initializeToggleLogin = function () {
  var $loginToggle = $("#ihLoginToggle"),
    $mobileLogin = $("#ihMobileLogin"),
    $notificationBar = $(".ihNotificationBar");

  $loginToggle.on("click", function (event) {
    event.preventDefault();

    if ($loginToggle.hasClass("is-active")) {
      if (!$notificationBar.hasClass("is-closed")) {
        $notificationBar.slideDown(400);
      }
      $loginToggle.removeClass("is-active");
      $mobileLogin.removeClass("is-active");
    } else {
      $("#nav-mobile-icon").removeClass("is-active");
      $("#nav-mobile").removeClass("is-active");
      if (!$notificationBar.hasClass("is-closed")) {
        $notificationBar.slideUp(400);
      }
      $loginToggle.addClass("is-active");
      $mobileLogin.addClass("is-active");
    }
  });
};

var initializeToggleNav = function () {
  var $mobileIcon = $("#nav-mobile-icon"),
    $mobileNav = $("#nav-mobile"),
    $notificationBar = $(".ihNotificationBar");

  $mobileIcon.on("click", function () {
    if ($mobileIcon.hasClass("is-active")) {
      if (!$notificationBar.hasClass("is-closed")) {
        $notificationBar.slideDown(400);
      }
      $mobileIcon.removeClass("is-active");
      $mobileNav.removeClass("is-active");
    } else {
      $("#ihLoginToggle").removeClass("is-active");
      $("#ihMobileLogin").removeClass("is-active");
      if (!$notificationBar.hasClass("is-closed")) {
        $notificationBar.slideUp(400);
      }
      $mobileIcon.addClass("is-active");
      $mobileNav.addClass("is-active");
    }
  });
};

var initializeMobileNav = function () {
  var $mobileLinks = $(
      ".navMobile__li:not(.navMobile__li--cta, .navMobile__li--icon, .navMobile__li--base)"
    ).find("> .navMobile__link"),
    $level2Links = $(".navMobile__level2__li").find("> .navMobile__link");

  function toggleDropdown($link) {
    var $parentItem = $link.parent(".navMobile__li--parent"),
      $dropdown = $link.next();

    if ($parentItem.hasClass("is-active")) {
      $parentItem.removeClass("is-active");
      $dropdown.slideUp();
      if (!$parentItem.hasClass("navMobile__level2__li")) {
        $parentItem
          .find(".is-active")
          .removeClass("is-active")
          .find(".navMobile__drop")
          .slideUp();
      }
    } else {
      if ($parentItem.siblings().hasClass("is-active")) {
        $parentItem
          .siblings()
          .removeClass("is-active")
          .find(".navMobile__drop")
          .slideUp();
        if (!$parentItem.hasClass("navMobile__level2__li")) {
          $parentItem
            .siblings()
            .find(".is-active")
            .removeClass("is-active")
            .find(".navMobile__drop")
            .slideUp();
        }
      }
      $parentItem.addClass("is-active");
      $dropdown.slideDown();
    }
  }

  $(".navMobile__drop").slideUp();

  $.each($mobileLinks, function (index, link) {
    $(link).on("click", function (event) {
      event.preventDefault();
      toggleDropdown($(this));
    });
  });

  $.each($level2Links, function (index, link) {
    $(link).on("click", function (event) {
      event.preventDefault();
      toggleDropdown($(this));
    });
  });
};

var forEach = function (array, callback, context) {
  for (var index = 0; index < array.length; index++) {
    callback.call(context, index, array[index]);
  }
};

var isIntersectionObserverSupported = "IntersectionObserver" in window;

if (isIntersectionObserverSupported) {
  var $headerObserver = document.querySelector("#header-observer");
  var $header = document.querySelector(".header");
  if ($headerObserver && $header) {
    var stickyObserver = new IntersectionObserver((entries, observer) => {
        entries[0].isIntersecting
          ? ($header.classList.remove("is-stuck"),
            $header.classList.add("not-stuck"))
          : ($header.classList.add("is-stuck"),
            $header.classList.remove("not-stuck"));
      });
    stickyObserver.observe($headerObserver);
  }
}

function initializeScroller() {
  var $scrollLinks = document.querySelectorAll(".scroller");

  forEach($scrollLinks, function (index, link) {
    var $targetSection = document.querySelector(link.getAttribute("href"));

    link.addEventListener("click", function (event) {
      event.preventDefault();
      $targetSection.scrollIntoView({ behavior: "smooth" });
    });
  });
}

initializeScroller();

var initializeViewPortCheck = function () {
  if (isIntersectionObserverSupported) {
    var $viewCheckElements = document.querySelectorAll(".check-view"),
      viewObserver = new IntersectionObserver(
        function (entries) {
          forEach(entries, function (index, entry) {
            entry.target.classList.add("in-view", entry.intersectionRatio > 0);
            if (entry.intersectionRatio > 0) {
              viewObserver.unobserve(entry.target);
            }
          });
        },
        { root: null, rootMargin: "10px", threshold: 0.25 }
      );

    forEach($viewCheckElements, function (index, element) {
      viewObserver.observe(element);
    });
  }
};

initializeViewPortCheck();
